module.exports = __webpack_public_path__ + "media/images/check-53b599c14fc9213a96ce7519dede397c.svg";